import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { putApi } from "../../utils/api";
import { API_REIMBURSEMENT_WITHDRAW } from "../../config/Endpoints";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import * as Yup from "yup";
import validations from "../../config/validation";
import axios from "axios";
import { API_GET_EMPLOYEE_FILE } from "../../config/Endpoints";
import DocumentViewer from "../../components/DocumentViewer";
import { RxEnterFullScreen } from "react-icons/rx";
import { MdDownload } from "react-icons/md";
const ReimbursementWithdrawRequest = ({
  reimbursementId,
  selectedReimbursementRequest,
  reimbursementStatusList,
  fetchList,
}) => {
  console.log(selectedReimbursementRequest);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [formData, setFormData] = useState({
    action: "WITHDRAW",
    comment: "",
  });
  const [errors, setErrors] = useState("");
  const validationSchema = Yup.object().shape({
    comment: validations.COMMENT_VALIDATION,
  });
  const [documentDetail, setDocumentDetail] = useState({
    url: null,
    type: null,
    name: null,
  });
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);

  const handleViewFile = async (fullPath, name) => {
    if (!fullPath) {
      toast.error("File path not available", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filepath = fullPath.split("/").slice(3).join("/");

    setIsLoading(true);
    try {
      console.log("Making API call...");
      const res = await axios.get(API_GET_EMPLOYEE_FILE, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: { filepath },
        responseType: "blob",
      });
      console.log("API response:", res);

      if (res.status === 200) {
        const fileBlob = new Blob([res.data], {
          type: res.data.type || "application/pdf",
        });
        const fileURL = window.URL.createObjectURL(fileBlob);

        setDocumentDetail({
          url: fileURL,
          type: res.data.type || "application/pdf",
          name: name || "Document",
          isFullscreen: false,
        });
        setShowDocumentViewer(true);
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error("Error loading file", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const action = formData.action || "WITHDRAW";
      await validationSchema.validate(formData, {
        abortEarly: false,
      });
      await putApi(
        API_REIMBURSEMENT_WITHDRAW +
          "?reimbursementRequestId=" +
          reimbursementId +
          "&comment=" +
          encodeURIComponent(formData.comment) +
          "&status=" +
          `${action}`,
        {},
        accessToken
      )
        .then((res) => {
          if (res.status === 200) {
            setIsLoading(false);
            toast.success(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            fetchList();
            const modalClose =
              document.getElementsByClassName("cancel-modal")[0];
            modalClose.click();
          } else {
            setIsLoading(false);
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            const modalClose =
              document.getElementsByClassName("cancel-modal")[0];
            modalClose.click();
          }
        })
        .catch((e) => {
          setIsLoading(false);
          toast.error(
            e?.response?.data?.message
              ? e?.response?.data?.message
              : "Something went wrong please try again.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
        });
    } catch (error) {
      setIsLoading(false);
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);
    }
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFormData({
      action: "",
      comment: "",
    });
    setErrors({});
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setErrors((prevFormData) => ({
      ...prevFormData,
      [name]: "",
    }));
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {isLoading && (
          <div className="overlay">
            <div className="loader-container">
              <TailSpin
                height="100"
                width="100"
                radius="1"
                color="blue"
                ariaLabel="tail-spin-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          </div>
        )}
        <div className="modal-header">
          <h5 className="modal-title text-center flex" id="staticBackdropLabel">
            Withdraw Reimbursement
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleReset}
          ></button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="action" className="has-asterisk">
                Action
              </label>
            </div>

            <div className="col-md-4">
              <select
                id="action"
                required
                name="action"
                className="border"
                value={formData.action}
                onChange={handleInputChange}
                disabled={true}
              >
                {/* <option value="">Select Action</option> */}
                <option value={"WITHDRAW"} selected>
                  WITHDRAW
                </option>
              </select>
            </div>
            <div className="col-md-2"></div>
          </div>
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="usercomment">User Comment</label>
            </div>
            <div className="col-md-4">
              {selectedReimbursementRequest?.userComment !== null && (
                <li>{parse(`${selectedReimbursementRequest?.userComment}`)}</li>
              )}
            </div>
            <div className="col-md-2"></div>
          </div>
          {selectedReimbursementRequest?.firstApproverComment !== null && (
            <div className="row mt-3">
              <div className="col-md-2"></div>
              <div className="col-md-4">
                <label htmlFor="comment">First Approver Comment</label>
              </div>
              <div className="col-md-4">
                {selectedReimbursementRequest?.firstApproverComment !==
                  null && (
                  <li>
                    {parse(
                      `${selectedReimbursementRequest?.firstApproverComment}`
                    )}
                  </li>
                )}
              </div>
              <div className="col-md-2"></div>
            </div>
          )}
          {selectedReimbursementRequest?.secondApproverComment !== null && (
            <div className="row mt-3">
              <div className="col-md-2"></div>
              <div className="col-md-4">
                <label htmlFor="comment">Second Approver Comment</label>
              </div>
              <div className="col-md-4">
                {selectedReimbursementRequest?.secondApproverComment !==
                  null && (
                  <li>
                    {parse(
                      `${selectedReimbursementRequest?.secondApproverComment}`
                    )}
                  </li>
                )}
              </div>
              <div className="col-md-2"></div>
            </div>
          )}
          {selectedReimbursementRequest?.thirdApproverComment !== null && (
            <div className="row mt-3">
              <div className="col-md-2"></div>
              <div className="col-md-4">
                <label htmlFor="comment">Third Approver Comment</label>
              </div>
              <div className="col-md-4">
                {selectedReimbursementRequest?.thirdApproverComment !==
                  null && (
                  <li>
                    {parse(
                      `${selectedReimbursementRequest?.thirdApproverComment}`
                    )}
                  </li>
                )}
              </div>
              <div className="col-md-2"></div>
            </div>
          )}
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="comment" className="has-asterisk">
                Comment
              </label>
            </div>
            <div className="col-md-4">
              <textarea
                rows={3}
                cols={5}
                className="border"
                name="comment"
                value={formData.comment}
                onChange={handleInputChange}
                required
              ></textarea>
              {errors.comment && (
                <small className="text-danger">{errors.comment}</small>
              )}
            </div>
            <div className="col-md-2"></div>
          </div>
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <label htmlFor="comment">Attachment</label>
            </div>
            <div className="col-md-4">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleViewFile(
                    selectedReimbursementRequest?.filePath,
                    selectedReimbursementRequest?.fileName
                  );
                }}
              >
                view
              </a>
            </div>
            <div className="col-md-2"></div>
          </div>
        </div>

        <div className="justify-content-center modal-footer">
          <button
            type="submit"
            className={isLoading ? "theme-button disabled " : "theme-button "}
          >
            Withdraw
          </button>
          <button
            type="button"
            className="theme-button bg-grey mx-3 w-35 cancel-modal"
            data-bs-dismiss="modal"
            onClick={handleReset}
          >
            Cancel
          </button>
        </div>
      </form>

      {showDocumentViewer && (
        <div
          className={`modal modal-document-viewer-wrapper ${
            showDocumentViewer ? "show d-block" : ""
          }`}
          tabIndex="-1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden={!showDocumentViewer}
        >
          <div
            className={`modal-dialog modal-dialog-centered ${
              documentDetail.isFullscreen ? "modal-fullscreen" : ""
            } ${documentDetail.type === "application/pdf" ? "modal-xl" : ""}`}
          >
            <div className="modal-content">
              <div className="modal-header modal-document-viewer-header">
                <div className="d-flex align-items-center">
                  <h5 className="m-0 fs-6">{documentDetail.name}</h5>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <button
                    type="button"
                    className="btn modal-header-btn"
                    onClick={() =>
                      setDocumentDetail((prev) => ({
                        ...prev,
                        isFullscreen: !prev.isFullscreen,
                      }))
                    }
                  >
                    <RxEnterFullScreen size="1.4rem" />
                  </button>
                  {documentDetail.type !== "application/pdf" && (
                    <button
                      type="button"
                      className="btn modal-header-btn"
                      onClick={() => {
                        const a = document.createElement("a");
                        a.href = documentDetail.url;
                        const parts = documentDetail.type.split("/");
                        a.download =
                          documentDetail.name + "." + parts[parts.length - 1];
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                      }}
                    >
                      <MdDownload size="1.5rem" />
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => {
                      URL.revokeObjectURL(documentDetail.url);
                      setShowDocumentViewer(false);
                    }}
                  ></button>
                </div>
              </div>
              <div
                className={`modal-body modal-document-viewer-body ${
                  documentDetail.type === "application/pdf" ? "modal-pdf" : ""
                }`}
              >
                {documentDetail.type === "application/pdf" ? (
                  <iframe src={documentDetail.url} className="w-100 h-100" />
                ) : (
                  <img
                    src={documentDetail.url}
                    className="w-100 h-100 object-fit-contain"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReimbursementWithdrawRequest;
